module.exports = __webpack_public_path__ + "static/media/eric_full.39b638fe.png";